"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeUrlFromWrongParams = void 0;
var _constants = require("./constants");
const sanitizeUrlFromWrongParams = url => {
  url.searchParams.delete(_constants.HEIGHT_PARAM);
  url.searchParams.delete(_constants.QUALITY_PARAM);
  url.searchParams.delete(_constants.WIDTH_PARAM);
  url.searchParams.delete(_constants.BACKGROUND_PARAM);
  url.searchParams.delete(_constants.IMAGE_BACKGROUND_PARAM);
};
exports.sanitizeUrlFromWrongParams = sanitizeUrlFromWrongParams;
//# sourceMappingURL=sanitizeUrlFromWrongParams.js.map